module.exports = __webpack_public_path__ + "static/1305332035-wide.a19db05f.jpg";